<script>
    import appConfig from '@src/app.config'
	import Layout from '@layouts/newdefaultform'
	import PageHeader from '@components/page-header'
	import productManage from '@components/list-manage-product'
	import Confirmation from '@components/confirmation'
	import { giftlistApi } from '@router/apiFiles/giftlistApi'
	import { productApi } from '@router/apiFiles/productApi'
	import { priceApi } from '@router/apiFiles/priceApi'

    /**
     * Page
     */
    export default {
        page: {
            title: 'Editar produtos',
            meta: [{ name: 'description', content: appConfig.description }],
        },
        components: {
            Layout, PageHeader, productManage, Confirmation
        },
        data() {
            return {
                title: 'Editar produtos',
                items: [
                    {
                        text: 'LaVille',
                        href: '/',
                    },
                    {
                        text: 'Listas',
                        href: '/',
                    },
                    {
                        text: 'Editar produtos',
                        active: true,
                    },
				],
				id: '',
				externalId: '',
				description: '',
				city: '',
				date: '',
				products: [],
      			page: 1,
				endOfPage: false,
				showConfirmation: false,
				skuIdToDelete: '',
				isBusy: false
            }
		},
        mounted() {
			this.fetchData();
			this.scroll();
        },
        methods: {
    		scroll () {
    		  var self = this;
    		  window.onscroll = () => {
    		    let bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight === document.documentElement.offsetHeight
    		    if (bottomOfWindow && !self.isBusy) {
    		      self.populateProducts();
    		    }
    		  }
    		},
            async fetchData() {
				var self = this;
				giftlistApi
					.getGiftlistByUrl({ url: self.$route.params.urlText })
					.then(function(data) {
						self.description = data.data.members;
						self.city = data.data.city;
          				self.date = data.data.date;
          				self.id = data.data.id;
						self.externalId = data.data.externalId;
						self.page = 1;
						self.endOfPage = false;			
						self.products = [];			  
          				self.populateProducts()
        			});
			},
			async populateProducts() {
				var self = this;
				if (self.id == '' || self.endOfPage == true) return;
				self.isBusy = true;
				giftlistApi.getProductsPaged({ giftlistId: self.id, page: self.page }).then(function(data) {
        			if (data.data.length == 0) {
          				self.endOfPage = true;
						self.isBusy = false;
          				return;
        			}
					var prodlist = data.data;
					self.page++;
					self.isBusy = false;

        			prodlist.forEach((item) => {

          				item.description = '';
          				item.imageUrl = '';
          				item.refCode = '';
          				item.hasListPrice = '';
          				item.listPrice = '';
          				item.price = '';
          				self.products.push(item);

            			productApi.GetProduct({ skuid: item.skuid }).then(function(data) {
            			  item.description = data.data.description;
            			  item.imageUrl = data.data.imageUrl;
            			  item.refCode = data.data.refCode;
            			});
            			priceApi.GetPrice({ skuid: item.skuid }).then(function(data) {
            			  item.hasListPrice = data.data.hasListPrice;
            			  item.listPrice = data.data.listPrice;
            			  item.price = data.data.price;
            			}, function(error){
							productApi.GetProductComplete({ skuid: item.skuid }).then(function(data) {
            				  item.description = data.description;
            				  item.imageUrl = data.imageUrl;
            				  item.refCode = data.reference;
            				  item.hasListPrice = data.hasListPrice;
            				  item.listPrice = data.listPrice;
            				  item.price = data.price;
            				});
						});

						/*
            			productApi.GetProductComplete({ skuid: item.skuid }).then(function(data) {
            			  item.description = data.description;
            			  item.imageUrl = data.imageUrl;
            			  item.refCode = data.reference;
            			  item.hasListPrice = data.hasListPrice;
            			  item.listPrice = data.listPrice;
            			  item.price = data.price;
            			}, function(error2) {
            			  productApi.GetProduct({ skuid: item.skuid }).then(function(data) {
            			    item.description = data.data.description;
            			    item.imageUrl = data.data.imageUrl;
            			    item.refCode = data.data.refCode;
            			  });
            			  priceApi.GetPrice({ skuid: item.skuid }).then(function(data) {
            			    item.hasListPrice = data.data.hasListPrice;
            			    item.listPrice = data.data.listPrice;
            			    item.price = data.data.price;
            			  });
            			});*/
						  
        			});
      			})
			},
			async changeProductQuantity(id, newQuantity) {
				if (newQuantity !== 'undefineed' && newQuantity.length > 0) {
					var self = this;
					giftlistApi.addProductOrUpdate({ giftlistId: self.id, skuId: id, quantity: newQuantity }).then(function(data) {

					});
				}
			},
			async goToAddProducts() {
				this.$router.push({ path: '/adicionarprodutos/' + this.$route.params.urlText })
			},
			deleteProduct(skuid) {
				this.skuIdToDelete = skuid;
				this.showConfirmation = true;
			},
			confirmDeleteProduct() {
				var self = this;
				giftlistApi.deleteProduct({ giftlistId: self.id, skuId: self.skuIdToDelete }).then(function(data){
					self.products.forEach((item, index) => {
						if (item.skuid == self.skuIdToDelete) self.products.splice(index, 1);
					});
					self.skuIdToDelete = '';
				});
				this.showConfirmation = false;
			},
			cancelDeleteProduct() {
				this.showConfirmation = false;
			}
        }
    }
</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />

		<div class="row">			
			<div class="col-md-8 offset-md-2">
				<div class="card">
					<div class="card-header custom">
					</div>
					<div class="card-body pt-2 pb-2">

						<h5 class="mb-4 header-title">Produtos</h5>
						
              			<b-button size="sm" @click="goToAddProducts()">Adicionar produtos</b-button>

						<div v-for="product of products" v-bind:key="product.id">
							<div class="media mt-1 border-top pt-3">
								<img :src="`${product.imageUrl}`" class="avatar rounded-circle mr-3" alt="" />
								<div class="media-body">
									<h6 class="mt-1 mb-0 font-size-15">{{ product.description }}</h6>
									<h6 class="text-muted font-weight-normal mt-1 mb-3"><strike v-if="product.hasListPrice">{{product.listPrice}}</strike> {{ product.price }}</h6>
									<h6 class="text-muted font-weight-normal mt-1 mb-3"><input type="text" v-model="product.wanted" @change="changeProductQuantity(product.skuid, product.wanted)" class="form-control-sm" /> desejados / {{product.won}} ganhos</h6>
								</div>
								<b-dropdown variant="black" right toggle-class="arrow-none text-muted pr-0">
    						    	<template v-slot:button-content>
										<i class="uil uil-ellipsis-v"></i>
    						    	</template>
    						    	<b-dropdown-item href="javascript:void(0);" variant="danger" @click="deleteProduct(product.skuid)">
										<i class="uil uil-trash mr-2"></i>Excluir
    						    	</b-dropdown-item>
    						  	</b-dropdown>
    						</div>
						</div>
					</div>
				</div>				
			</div>
			<Confirmation confirmationtext="Tem certeza que deseja excluir este produto?" :showDialog="showConfirmation" @confirm="confirmDeleteProduct()" @cancel="cancelDeleteProduct()" />
		</div>
		
 
  </Layout>
</template>

<style scoped>


.ext {
    text-align: center
}

.int {
    margin: 0 auto;
    text-align: left;
    position: relative;
    /*width: 1170px*/
}


input.form-control-sm {
	width: 50px;
}

.show-buy .add-list a::before {
  content: 'Adicionar';
}

</style>

